var e="".concat(process.env.NEXT_PUBLIC_STATIC_URL,"/images/loader.gif");export{e as LOADER_URL};
//# sourceMappingURL=loader.constants.js.map
